import cx from 'classnames'
import React from 'react'
import { Tag } from '../Tag'
import './styles.scss'

const clsPrefix = 'app-transport-tag'

interface TransportTagProps {
  // Color of the tag
  color?: string
  text?: string | null
  textColor?: string
  icon?: React.ReactNode
  className?: string
}

export const TransportTag = React.forwardRef<HTMLSpanElement, TransportTagProps>(
  ({ color, text, textColor, icon, className }, ref) => (
    <div className={`${clsPrefix}-container`}>
      {icon ? <span className={`${clsPrefix}-icon`}>{icon}</span> : null}
      {text ? (
        <Tag ref={ref} className={cx(`${clsPrefix}-tag`, className)} color={color || 'white'}>
          <span className={`${clsPrefix}-tag-content`} style={{ color: textColor || 'black' }}>
            {text}
          </span>
        </Tag>
      ) : null}
    </div>
  )
)
TransportTag.displayName = 'TransportTag'

export default TransportTag
